import { ButtonGroup } from '@mui/material'
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined'
import SidebarAction from '/components/sidebar-action'
import { useLocation, useNavigate } from 'react-router-dom'

const menuItems = [
  { label: 'Pass Activity', path: '/reports-and-statistics/pass-activity' },
  { label: 'Adoption', path: '/reports-and-statistics/adoption' },
  { label: 'Template Changes', path: '/reports-and-statistics/template-changes' },
  { label: 'Installs', path: '/reports-and-statistics/installs' },
  { label: 'Scans', path: '/reports-and-statistics/scans' },
  { label: 'Pass Types', path: '/reports-and-statistics/pass-types' },
  { label: 'Install Report', path: '/reports-and-statistics/install-report' },
  { label: 'Managed Pass Data', path: '/reports-and-statistics/managed-pass-data' }
]

const Menu = () => {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div className='flex flex-row justify-end w-full'>
      <ButtonGroup variant="text" aria-label="Statistics sections">
        {menuItems.map(item => (
          <SidebarAction
            key={item.path}
            label={item.label}
            icon={item.label === 'Installs' ? <SyncAltOutlinedIcon /> : <AssessmentOutlinedIcon />}
            active={location.pathname === item.path}
            onClick={() => navigate(item.path)}
          />
        ))}
      </ButtonGroup>
    </div>
  )
}

export default Menu
